import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  QueryConstraint,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useLoadPhoto from "../loadPhoto";

const useColection = <T>(collectionId: string) => {
  const collectionRef = collection(db, collectionId);
  const upload = useLoadPhoto(collectionId);

  const get = async (condition?: QueryConstraint[]) => {
    const queryData = query(collectionRef, ...(condition || []));

    const data = await getDocs(queryData);

    return data.docs.map((doc) => ({ ...(doc.data() as T), id: doc.id }));
  };

  const edit = async (id: string, fieldsData: Record<string, any>) => {
    const document = doc(db, collectionId, id);
    return updateDoc(document, fieldsData);
  };
  const create = async (fieldsData: Record<string, any>) => {
    return addDoc(collectionRef, fieldsData);
  };

  const deleteData = async (id: string) => {
    const userDoc = doc(db, collectionId, id);
    return deleteDoc(userDoc);
  };

  const uploadPhoto = (userId: string, file: File) => {
    return upload(userId, file);
  };
  const savePhotoUrl = async (id: string, newFields: Record<string, any>) => {
    const userDoc = doc(db, collectionId, id);
    return updateDoc(userDoc, newFields);
  };
  return { get, edit, create, deleteData, uploadPhoto, savePhotoUrl };
};

export default useColection;
